module.exports = __webpack_public_path__ + "static/img/indexg.7515f1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexg.png
// module id = s9z7
// module chunks = 1